import Vue from 'vue';
import VueGtag from 'vue-gtag';

if (process.env.GOOGLE_ANALYTICS_ENABLED) {
  var config = {
    id: process.env.GOOGLE_ANALYTICS_ID
  };

  if (process.env.GOOGLE_ANALYTICS_DEBUGMODE) {
    config.debug_mode = true;
  }

  Vue.use(VueGtag, {
    config: config
  });
}